<template>
  <div class="card_border">
    <div class="chart-controls">
      <el-button v-show="chartType === 'chart_line'" v-if="!playStatus" @click="playStatus=true" type="primary" icon="el-icon-video-play" size="small">播放</el-button>
      <el-button v-show="chartType === 'chart_line'" v-else @click="playStatus=false" type="danger" icon="el-icon-video-play" size="small">停止</el-button>
      <n-date-picker
        v-if="$is_dock_env"
        size="small"
        v-model="valueTime"
        type="datetimerange"
        :picker-options="pickerOptions2"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
        @change="handleTimeChange"
        >
      </n-date-picker>
      <el-date-picker
        v-else
        size="small"
        v-model="valueTime"
        type="datetimerange"
        :picker-options="pickerOptions2"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm"
        align="right"
        @change="handleTimeChange"
        >
      </el-date-picker>

      <el-radio-group v-model="mainChartType" size="small">
        <el-radio-button v-for="tp in chartTypes" :key="tp.value" :label="tp.value" v-show="!(tp.model == 'pro' && model != 1)">{{tp.name}}</el-radio-button>
        <!-- <el-radio-button label="pm10">PM₁₀</el-radio-button>  -->
        
      </el-radio-group>

      <el-radio-group v-model="chartType" size="small">
        <el-radio-button label="chart_line">曲线</el-radio-button>
        <el-radio-button label="chart_24h">时段统计</el-radio-button> 
      </el-radio-group>
      <span style="margin-left: 15px" v-show="$model === '1'">
        <el-button type="primary" size="small" @click="toExportStat">微站偏差值分析</el-button>
        <el-tooltip placement="top">
          <div slot="content">
            微站的日均值 减去 微站周边5km微站的平均值 为该微站一天的的偏差值。
            <br>根据所选天数加和平均得到每个微站平均每天的偏差值。
          </div>
          <i class="el-icon-info"></i>
        </el-tooltip>
      </span>
      
    </div>
    <div v-show="chartType == 'chart_line'" :style="{height: height}" class="chart" :id="id" :option="option" style="overflow: hidden;"></div> 
    <div v-show="chartType == 'chart_24h' " :style="{height: height}" class="chart_24h" :id="id_24h" :option="option_24h" style="overflow: hidden;"></div> 
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Highcharts from 'highcharts'
  import exporting from 'highcharts/modules/exporting';
  import { check_time_range, lineDataTo24H } from '@/utils/util'
  import { nuofang_jngrid_api } from "@/config/common"
  exporting(Highcharts);

  Highcharts.setOptions({
    global: {
      useUTC: false
    }
  });
  import {pickerOptions2,option,timeGroupOption,tpOptions,gf_level_options,option_24h} from '../options/option'
  const chartTypes = [
    {name:'PM₂.₅', value: 'pm25', title: 'PM₂.₅'},
    {name:'PM₁₀', value: 'pm10', title: 'PM₁₀'},
    { value: "no2", title: "NO₂", name: "NO₂"},
    { value: "o3", title: "O₃", name: "O₃", model: 'pro'},
    { value: "so2_f", title: "SO₂", name: "SO₂", model: 'pro'},
    { value: "tvoc", title: "VOCs", name: "VOCs", model: 'pro'},
    { value: "co_f", title: "CO", name: "CO", model: 'pro'},
  ]
	export default {
		name: 'HeadTag',
		props: {
      height: String,
      time_type: String
		},
    data () {
      return {
        pickerOptions2,
        chartTypes,
        // valueTime: [this.$moment().subtract(1, 'months').format("YYYY-MM-DD HH:mm:ss"),this.$moment().format("YYYY-MM-DD HH:mm:ss")],
        mainChartType: 'pm10',
        id:'test',
        id_24h:'chart_24h',
        chart:null,
        chart_24h:null,
        option,
        option_24h,
        pollution:0,
        bindCall: true,
        playStatus: false
      }
    },
    computed: {
      ...mapState(["initBaseInfo", "timeRange", "line_t", "chartTypeStore", "model"]),
      chartType: {
        get() { return this.chartTypeStore },
        set(v) {
          this.$store.commit('setChartType', v)
        }
      },
      valueTime: {
        get() { return this.timeRange },
        set(v) {
          if (this.bindCall){
            this.bindCall = false
            return 
          }
          console.log('setTimeRange')
          this.$store.commit("setTimeRange", v)
        }
      }
    },
    watch: {
      initBaseInfo() {
        if (this.initBaseInfo){
          this.initChart()    
        }
      },
      mainChartType() {
        this.$emit("handleChartTypeChange", this.mainChartType)
      },
      chartType() {
        if (this.chartType == 'chart_24h'){
          this.draw24hChart()
        }
      },
      playStatus() {
        if (this.playStatus) {
          this.stopPlay()
          this.startPlay()
        }else{
          this.stopPlay()
        }
      }
    },
    mounted(){
      
    },
    methods:{
      initChart(){
        this.option.chart.events={
          click: event => {
            this.pollution = event.xAxis[0].axis.chart.hoverPoint.y.toFixed(1)
            var t = event.xAxis[0].axis.chart.hoverPoint.x
            // this.$emit('changeLineT', {t, chartType})
            this.$store.commit('setlineT', t)
          }
        }
        this.option.plotOptions={
          series: {
            cursor: 'pointer', 
            connectNulls:true,
            events: {
              click: e => {
                var t = e.point.x
                // this.$emit('changeLineT', {t, chartType})
                this.$store.commit('setlineT', t)
              }
            }
          }
        }
        this.chart = Highcharts.chart(this.id,this.option);

        this.$emit('initChart', {chart: this.chart})
        this.handleTimeChange()
      },
      draw24hChart() {
        var _this = this
        let series_data_24h = []
        let series = this.chart.series
        let hours = []
        for (let i=0; i < 24; i++){
          hours.push(i)
        }
        for (let i of series){
          let series_data = i.data
          let hour_data = lineDataTo24H(series_data)
          series_data_24h.push({name: i.name, data: hour_data, color: i.color})
        }
        this.option_24h.xAxis = {
          categories:hours
        }
        let t1 = this.$moment(this.valueTime[0])
        let t2 = this.$moment(this.valueTime[1])
        let timeStart1, timeStart2, d_value
        timeStart1 = this.$moment(this.valueTime[0]).get('date')
        timeStart2 = this.$moment(this.valueTime[0]).get('isoWeekday')
        d_value = this.$moment(this.valueTime[1]).diff(this.valueTime[0], 'days')
        if((timeStart1===1 && (d_value===28 || d_value===30 || d_value===31)) || (timeStart2===1 && d_value === 7)) {
          this.option_24h.plotOptions={
            series: {
              cursor: 'pointer', 
              connectNulls: true,
              allowPointSelect: true,
              events: {
                click: function(e) {
                  let hour = e.point.x
                  let chartType = _this.chartType
                  _this.$emit('changeTimeT', {hour, chartType})
                }
              }
            }
          }
        } else {
          this.option_24h.plotOptions = {}
        }
        this.option_24h.series = series_data_24h
        this.chart_24h = Highcharts.chart(this.id_24h,this.option_24h);
      },
      handleTimeChange(e) {
        var t1 = this.$moment(this.valueTime[0]).valueOf()
        var t2 = this.$moment(this.valueTime[1]).valueOf()
        let start_time = this.$moment(t1).format('YYYY-MM-DD HH:mm:ss')
        let end_time = this.$moment(t2).format('YYYY-MM-DD HH:mm:ss')
        this.valueTime = [start_time,end_time]
        this.$emit("handleTimeChange", this.valueTime)
      },
      toExportStat() {
        var t1 = this.$moment(this.valueTime[0]).valueOf()
        var t2 = this.$moment(this.valueTime[1]).valueOf()
        let start_time = this.$moment(t1).format('YYYY-MM-DD')
        let end_time = this.$moment(t2).format('YYYY-MM-DD')
        const base_url = this.$is_dock_env ? nuofang_jngrid_api : 'http://jngrid.novaecs.com'
        window.open(`${base_url}/api/data_audit/stat_wz/deviationStat?start_date=${start_time}&end_date=${end_time}`)
      },
      startPlay() {
        let series = this.chart.series
        if (!series.length) {
          return 
        }
        let seriesData = []
        for (var s of series) {
          if (s.xData.length > seriesData.length) {
            seriesData = s.xData
          }
        }
        if (!seriesData.length) return 
        if (this.line_t >= seriesData[seriesData.length - 1]) {
          this.$store.commit('setlineT', seriesData[0])
        }
        this.interval = setInterval(()=>{
          let nextList = seriesData.filter(x=>x > this.line_t)
          if (nextList.length) {
            let nextT = nextList[0]
            this.$store.commit('setlineT', nextT)
          }else {
            this.playStatus = false
          }
        }, 1000)
      },
      stopPlay() {
        this.interval && clearInterval(this.interval)
      }
    }
	}
</script>

<style>
.head-tag{
  display: inline-block;
  background-color: #5ab1f0;
  width: 5px;
  height: 21px;
  vertical-align: top;
  margin-right: 10px
}
.card_border {
  border:1px solid #d8dde3;
}

.chart-controls {
  height: 40px;
  padding: 5px 10px
}
</style>


// WEBPACK FOOTER //
// src/components/MainChart.vue